import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgInfoFilled60 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60ZM27.6341 25.5438C27.358 25.5438 27.1341 25.7676 27.1341 26.0438V44.0125C27.1341 44.2886 27.358 44.5125 27.6341 44.5125H32.531C32.8071 44.5125 33.031 44.2886 33.031 44.0125V26.0438C33.031 25.7676 32.8071 25.5438 32.531 25.5438H27.6341ZM30.144 21.1387C29.2021 21.1387 28.4241 20.9134 27.8098 20.463C27.1956 20.0125 26.8884 19.2959 26.8884 18.3131C26.8884 17.2074 27.1956 16.4703 27.8098 16.1018C28.4241 15.6923 29.2021 15.4875 30.144 15.4875C30.963 15.4875 31.6796 15.6923 32.2939 16.1018C32.9491 16.4703 33.2767 17.2074 33.2767 18.3131C33.2767 19.3368 32.9491 20.0739 32.2939 20.5244C31.6796 20.9339 30.963 21.1387 30.144 21.1387Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoFilled60);

export { ForwardRef as ReactComponent };
//# sourceMappingURL=InfoFilled60.svg.js.map
